import "./button.css";

const Button = ({ visible }) => {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="style_button">
      <button
        className="button-sc"
        style={{
          opacity: visible ? 1 : 0,
          visibility: visible ? "visible" : "hidden",
          transition: "opacity 0.8s, visibility 0.8s",
        }}
        onClick={handleClick}
        aria-label="Remonter en haut"
      >
        <div className="style__svg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
          >
            <path d="M24.567 20.862a1.619 1.619 0 000-2.283l-7.417-7.433a1.618 1.618 0 00-2.3 0l-7.417 7.433a1.619 1.619 0 000 2.283 1.619 1.619 0 002.283 0l6.283-6.283 6.283 6.283a1.619 1.619 0 002.283 0z"></path>
          </svg>
        </div>
      </button>
    </div>
  );
};

export default Button;
